import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sales-dna',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: [],
})
export class SalesDnaComponent {
  title: string = 'Sales DNA';
  name: string | any = '';
  constructor(public route: ActivatedRoute) {}
}
